import React from 'react';

import NewCoursePage from './NewCoursePage';

const NewLegal = props => (
  <NewCoursePage
    {...props}
    videoLink="nnsxHwg9iVI"
    header={'Legal Considerations'}>
    {/* <h4>The Ontario Human Rights Code</h4> */}
    <p className="new-course__body__content__para">
      It is a fundamental human right for all people to be free from
      discrimination and to receive equal treatment as stated in The
      Ontario Human Rights Code.
    </p>
    <hr />
    <h5>Important Takeaways</h5>
    <ol className="new-course__body__content__olist">
      <li>
        Your customers have the right to equal access to your accessible
        vehicle without discrimination because of their disability - i.e.
        you can't refuse to transport someone with a service animal.
      </li>
      <li>
        Your customers are protected from harassment, which is any unwanted
        physical or verbal behaviour that offends, degrades, or humiliates.
        <ul className="new-course__body__content__olist--ulist">
          <li>
            Any manner of sexual harassment can be viewed as an offence.
          </li>
          <li>
            Personal space, the distance around their body that a person
            treats as private, is cultural and unique to each individual.
            It is important for drivers to explain what they are going to
            do and ask their customer’s permission before entering their
            personal space to do it, e.g. in assisting with a seat belt.
          </li>
        </ul>
      </li>
    </ol>

    <hr />
    <h4>The Accessibility for Ontarians with Disabilities Act</h4>
    <p className="new-course__body__content__para">
      The A.O.D.A develops and enforces accessibility standards by
      identifying, removing and preventing barriers for people with
      disabilities in areas of daily life. It applies to all organizations
      in Ontario and its goal is to transition Ontario to be completely
      accessible for people with disabilities by 2025.
    </p>
    <h5>A.O.D.A Accessibility Standards</h5>

    <ol className="new-course__body__content__olist">
      <li>
        Customer Service Standard
        <ul className="new-course__body__content__olist--ulist">
          <li>
            Business practices and training to provide quality customer
            service to people with disabilities.
          </li>
        </ul>
      </li>
      <li>
        Information & Communication Standard
        <ul className="new-course__body__content__olist--ulist">
          <li>
            Removal of barriers in access to information. The standards
            could include information being provided in person, cell phone,
            print or website.
          </li>
        </ul>
      </li>
      <li>
        Employment Standard
        <ul className="new-course__body__content__olist--ulist">
          <li>
            Addresses employment practices like hiring practices that don't
            discriminate against people with a disability.
          </li>
        </ul>
      </li>
      <li>
        Transportation Standard
        <ul className="new-course__body__content__olist--ulist">
          <li>
            Accessible transportation is crucial for daily life including
            work, attending school, shopping or socializing.
          </li>
        </ul>
      </li>
      <li>
        Design of Public Spaces Standard
        <ul className="new-course__body__content__olist--ulist">
          <li>
            Addresses access into and within buildings and spaces including
            things like accessible pathways, door entries, parking and
            signs.
          </li>
        </ul>
      </li>
    </ol>

    <hr />
    <h5>Important Takeaway: Customer Service</h5>
    <ol className="new-course__body__content__olist">
      <li>
        Ensure people with disabilities are allowed to be accompanied by
        service animals and support persons without limiting the service
        and without additional cost.
      </li>
      <li>
        Communicate with passengers in a manner appropriate for the
        person's disability.
      </li>
      <li>
        It is illegal to refuse service to a person with a disability
        because they have a service animal.
      </li>
    </ol>
    <br />
    <br />
  </NewCoursePage>
);

export default NewLegal;



// WEBPACK FOOTER //
// ./src/components/NewCourse/NewLegal.js